import createLucideIcon from '../createLucideIcon';

const Equal = createLucideIcon('Equal', [
  ['line', { x1: '5', y1: '9', x2: '19', y2: '9', key: 'p612hi' }],
  ['line', { x1: '5', y1: '15', x2: '19', y2: '15', key: 'e39u1i' }],
]);

export default Equal;
